import React from 'react';
import GeckoFieldBase from '../_base';
import { APP_CONST } from '../../../../constants';

class GeckoFieldText extends GeckoFieldBase {

	attrs() {
		return {
			id             : this.renderId(),
			[`aria-label`] : this.renderAriaLabel(),
			className      : 'file:text-foreground placeholder:text-slate-500 selection:bg-primary selection:text-primary-foreground border-input hover:border-slate-400 flex h-10 w-full min-w-0 rounded-sm border bg-transparent px-3 py-1 text-base transition-[color,box-shadow,border-color] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-slate-50 disabled:text-foreground md:text-sm focus-visible:border-slate-500 focus-visible:ring-slate-400/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive autofill:font-sans autofill:bg-white autofill:text-foreground autofill:shadow-[0_0_0_1000px_#fff_inset]',
			type           : this.getType(),
			autoCorrect    : this.isEmail() ? 'on' : 'off',
			autoCapitalize : this.isEmail() ? 'words' : 'none',
			autoComplete   : this.isEmail() ? 'on' : 'off',
			disabled       : this.isDisabled(),
			onChange       : this.handleChange.bind(this),
			onBlur         : this.handleBlur.bind(this),
			placeholder    : this.config().placeholder || this.field().placeholder,
			value          : this.value(),
			ref: this.ref(),
			...this.attributes()
		};
	}

	getType()
	{
		switch(this.field().type) {
			case 'email':
				return 'email';
			case 'tel':
				return 'tel';
			default:
				return 'text';
		}
	}

	isEmail() {
		return this.field().type === APP_CONST.FIELD_TYPE_EMAIL;
	}

	render() {
		return (<input {...this.attrs()} />);
	}

}

export default GeckoFieldText;